import { useState } from "react";

const SLIDES = [
  {
    icon: "🌾",
    title: "農援へようこそ",
    body: "「補助金って難しそう」「農協に断られた」という農家さんのために作りました。\n\n国や県が用意している「返済不要のお金のサポート」を、あなたの状況に合わせて探せます。",
    sub: "補助金を知らなくても大丈夫です",
  },
  {
    icon: "📋",
    title: "使い方は3ステップだけ",
    steps: [
      { n: "1", label: "やりたいことを選ぶ", desc: "「農機を新しくしたい」「農業を始めたい」など、今の状況を選ぶだけ" },
      { n: "2", label: "AIと話して整理する", desc: "難しい言葉は使いません。会話形式で補助金の候補を絞ります" },
      { n: "3", label: "行政書士へつなぐ", desc: "申請は行政書士がサポート。採択されるまで費用ゼロの場合がほとんど" },
    ],
  },
  {
    icon: "🔒",
    title: "安心してお使いください",
    points: [
      { icon: "✅", text: "個人情報の入力は最低限でOK" },
      { icon: "✅", text: "入力内容は自動送信されません" },
      { icon: "✅", text: "あなたがコピーして行政書士に送る形式" },
      { icon: "✅", text: "AIとのチャット内容は外部に共有されません" },
      { icon: "✅", text: "無料で診断・相談できます" },
    ],
  },
];

export default function TutorialScreen({ onDone }) {
  const [slide, setSlide] = useState(0);
  const isLast = slide === SLIDES.length - 1;
  const s = SLIDES[slide];

  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%", background:"#fff" }}>
      {/* スライド本体 */}
      <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"2rem 1.5rem", textAlign:"center" }}>

        <div style={{ fontSize:"4rem", marginBottom:"1rem" }}>{s.icon}</div>
        <h2 style={{ fontSize:"1.3rem", fontWeight:800, color:"#1a4a2e", marginBottom:"0.75rem" }}>{s.title}</h2>

        {/* スライド① */}
        {s.body && (
          <p style={{ fontSize:"0.9rem", color:"#444", lineHeight:1.8, whiteSpace:"pre-line", marginBottom:"0.75rem" }}>{s.body}</p>
        )}
        {s.sub && (
          <div style={{ background:"#e8f5e9", color:"#2e7d32", fontWeight:700, fontSize:"0.82rem", borderRadius:99, padding:"0.35rem 1rem" }}>
            {s.sub}
          </div>
        )}

        {/* スライド② */}
        {s.steps && (
          <div style={{ width:"100%", display:"flex", flexDirection:"column", gap:"0.75rem", textAlign:"left", marginTop:"0.5rem" }}>
            {s.steps.map((step) => (
              <div key={step.n} style={{ display:"flex", gap:"0.85rem", alignItems:"flex-start", background:"#f9fafb", borderRadius:12, padding:"0.85rem" }}>
                <div style={{ minWidth:"2rem", height:"2rem", background:"#1a4a2e", color:"#fff", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800, fontSize:"0.9rem" }}>
                  {step.n}
                </div>
                <div>
                  <div style={{ fontWeight:700, fontSize:"0.88rem", color:"#1a4a2e", marginBottom:"0.2rem" }}>{step.label}</div>
                  <div style={{ fontSize:"0.78rem", color:"#666", lineHeight:1.5 }}>{step.desc}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* スライド③ */}
        {s.points && (
          <div style={{ width:"100%", display:"flex", flexDirection:"column", gap:"0.6rem", textAlign:"left", marginTop:"0.5rem" }}>
            {s.points.map((p, i) => (
              <div key={i} style={{ display:"flex", gap:"0.75rem", alignItems:"center", background:"#f9fafb", borderRadius:10, padding:"0.75rem 1rem" }}>
                <span style={{ fontSize:"1.1rem" }}>{p.icon}</span>
                <span style={{ fontSize:"0.88rem", color:"#333", fontWeight:500 }}>{p.text}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ドットとボタン */}
      <div style={{ padding:"1rem 1.5rem 2rem" }}>
        {/* ドット */}
        <div style={{ display:"flex", justifyContent:"center", gap:"0.5rem", marginBottom:"1rem" }}>
          {SLIDES.map((_, i) => (
            <div
              key={i}
              onClick={() => setSlide(i)}
              style={{ width: i === slide ? "1.5rem" : "0.5rem", height:"0.5rem", borderRadius:99, background: i === slide ? "#1a4a2e" : "#ddd", transition:"all 0.3s", cursor:"pointer" }}
            />
          ))}
        </div>

        {/* ボタン */}
        <button
          onClick={() => isLast ? onDone() : setSlide(slide + 1)}
          style={{ width:"100%", background:"#1a4a2e", color:"#fff", fontWeight:800, fontSize:"1rem", borderRadius:12, padding:"1rem", border:"none", cursor:"pointer" }}
        >
          {isLast ? "さっそく使ってみる →" : "次へ →"}
        </button>

        {!isLast && (
          <button
            onClick={onDone}
            style={{ width:"100%", background:"none", border:"none", color:"#aaa", fontSize:"0.82rem", marginTop:"0.5rem", cursor:"pointer", padding:"0.4rem" }}
          >
            スキップ
          </button>
        )}
      </div>
    </div>
  );
}
